import React, { Fragment, useEffect, useState } from "react";
import classnames from "classnames";

export default function AppraisalSettingsBar(props){
    const { activeTab, toggle, loginUser } = props;
  const [backToHome, setBackToHome] = useState(null);

  return(
    <Fragment>
    <ul className="list-unstyled components">
      <li className={classnames({ active: activeTab === "1" })}>
        <a
          href={"/companylocation"}
          aria-expanded="false"
          onClick={() => toggle("1")}
        >
          <i className="fas fa-home"></i>
          <span>Back</span>
        </a>
      </li>
      <hr></hr>
   <li
  className={classnames({
    active: activeTab === "/questionsforappraisee",
  })}
>
  <a
    href="/questionsforappraisee"
    onClick={() => toggle("/questionsforappraisee")}
    style={{
      display: "flex",        // make icon and text inline
      alignItems: "center",   // vertically center
     
          
    }}
  >
    <i className="far fa-compass" ></i>
    <span>Questions For Appraisee</span>
  </a>
</li>
      <li
        className={classnames({
          active: activeTab === "/primarygoals",
        })}
      >
        <a href="/primarygoals" onClick={() => toggle("/primarygoals")}>
        <i className="fas fa-briefcase"></i>
          <span>Primary Goals</span>
        </a>
      </li>
      <li className={classnames({ active: activeTab === "/reviewrating" })}>
        <a
          href="/reviewrating"
          onClick={() => {
            toggle("/reviewrating");
          }}
        >
          <i className="fas fa-briefcase"></i>
          <span>Review Ratings</span>
        </a>
      </li>
      <li className={classnames({ active: activeTab === "/attribute" })}>
        <a
          href="/attribute"
          onClick={() => {
            toggle("/attribute");
          }}
        >
          <i className="fas fa-address-card"></i>
          <span>Behavioural Attributes</span>
        </a>
      </li>
      <li className={classnames({ active: activeTab === "/potential" })}>
        <a
          href="/potential"
          onClick={() => {
            toggle("/potential");
          }}
        >
          <i className="far fa-building"></i>
          <span>Appraisee Potential </span>
        </a>
      </li>
      
      
      
    </ul>
  </Fragment>
  );

}